import type { SessionMembership } from '@kratispot/shared';

// §8: the venue is in the address as the day is, by slug rather than by id.
export const VENUE_PARAM = 'venue';

// Per account: two people on one phone keep their own venue. §4
export const venueKey = (userId: string) => `kratispot.venue.${userId}`;

// Remembered because the owner's screens carry no query of their own.
export function readVenue(userId: string): string | null {
  try {
    return window.localStorage.getItem(venueKey(userId));
  } catch {
    return null;
  }
}

export function rememberVenue(userId: string, slug: string): void {
  try {
    window.localStorage.setItem(venueKey(userId), slug);
  } catch {
    // A private window forgets; the address still carries it for this visit.
  }
}

const bySlug = (venues: readonly SessionMembership[], slug: string | null) =>
  slug === null ? undefined : venues.find((venue) => venue.venueSlug === slug);

// The address, then this device, then the first venue they may work in. §8
export function currentVenue(
  venues: readonly SessionMembership[],
  asked: string | null,
  remembered: string | null,
): SessionMembership | undefined {
  return bySlug(venues, asked) ?? bySlug(venues, remembered) ?? venues[0];
}
